import { Middleware } from "@reduxjs/toolkit";
import {
  showNotification,
  NotificationType,
} from "../slices/notificationSlice";
import { getLocalizedErrorMessage, handleTokenExpiration } from "../utils/errorUtils";

export const axiosMiddleware: Middleware =
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    if (action.type.endsWith("/rejected")) {
//console.log('action:', action)
      const errorMessage = getLocalizedErrorMessage(action.payload, action.error?.message);

      dispatch(
        showNotification({
          type: NotificationType.Error,
          message: errorMessage,
        })
      );

      // 处理token过期
      handleTokenExpiration(action.payload?.code);
    } else if (action.type.endsWith("/fulfilled")) {
      const successMessage = action.payload?.message;// || "Sucess!";
      if (successMessage) {
        dispatch(
          showNotification({
            type: NotificationType.Success,
            message: successMessage,
          })
        );
      }
    }

    return next(action);
  };
